import React from 'react'
import { StyledTitle, StyledRow } from './styled'
import { Col } from 'react-bootstrap'
import { useHistory } from 'react-router-dom'
import { Button } from './../../components'

const TitleButtonBlock = (props) => {
    const history = useHistory()
    const handleRedirect = () => history.push(props.button.url)

    return(
        <StyledRow className='px-0 mx-0'>
            <Col xs={{
                span: 10,
                offset: 1
            }} className='d-flex justify-content-center align-items-center flex-column'>
                <StyledTitle className='mb-3'>
                    {props.title}
                </StyledTitle>
                <Button label={props.button.title} onClick={handleRedirect} fontSize='1.2em'/>
            </Col>
        </StyledRow>
    )
}

export default TitleButtonBlock